<div class="mb-2">
  <app-custom-instructions-form
    [(ngModel)]="customInstruction"
    (ngModelChange)="
      onCustomInstructionChange($event)
    "></app-custom-instructions-form>
</div>

<form [formGroup]="form" class="flex flex-col gap-4">
  <div>
    <label for="name" class="font-bold !block mb-2">
      How many guests should be considered?
    </label>
    <p-selectbutton
      [options]="guestOptions"
      formControlName="guests"></p-selectbutton>
  </div>
  <div>
    <label for="name" class="font-bold !block mb-2">
      How many sections should be considered?
    </label>
    <p-selectbutton
      [options]="sectionOptions"
      formControlName="sections"></p-selectbutton>
  </div>
  <div class="flex justify-end gap-2">
    <p-button
      label="Cancel"
      [text]="true"
      severity="secondary"
      (click)="handleCancelClick()" />
    <p-button
      label="Save"
      [outlined]="true"
      severity="primary"
      (click)="handleSaveClick()" />
  </div>
</form>
